/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindFileQueryResponse2
 */
export interface FindFileQueryResponse2 {
    /**
     * 
     * @type {string}
     * @memberof FindFileQueryResponse2
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FindFileQueryResponse2
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FindFileQueryResponse2
     */
    mimeType: string;
    /**
     * 
     * @type {string}
     * @memberof FindFileQueryResponse2
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof FindFileQueryResponse2
     */
    size: number;
    /**
     * 
     * @type {string}
     * @memberof FindFileQueryResponse2
     */
    extension?: string;
    /**
     * 
     * @type {string}
     * @memberof FindFileQueryResponse2
     */
    url: string;
}

/**
 * Check if a given object implements the FindFileQueryResponse2 interface.
 */
export function instanceOfFindFileQueryResponse2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "mimeType" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "size" in value;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function FindFileQueryResponse2FromJSON(json: any): FindFileQueryResponse2 {
    return FindFileQueryResponse2FromJSONTyped(json, false);
}

export function FindFileQueryResponse2FromJSONTyped(json: any, ignoreDiscriminator: boolean): FindFileQueryResponse2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'mimeType': json['mimeType'],
        'type': json['type'],
        'size': json['size'],
        'extension': !exists(json, 'extension') ? undefined : json['extension'],
        'url': json['url'],
    };
}

export function FindFileQueryResponse2ToJSON(value?: FindFileQueryResponse2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'mimeType': value.mimeType,
        'type': value.type,
        'size': value.size,
        'extension': value.extension,
        'url': value.url,
    };
}

